// Aligned with promo-backend/services/launcherProtocol.js and Suite's validators.
export const codes = ['ZEHUB', 'ZESCAN', 'ZEUS', 'ANTION', 'ZEVENDOR', 'ZEREPORTES', 'ZECHECK', 'ZEPICK']
const record = value => !!value && typeof value === 'object' && !Array.isArray(value)
const keys = (value, expected) => record(value) && Object.keys(value).sort().join(',') === expected.slice().sort().join(',')
const text = value => typeof value === 'string' && value.length > 0 && value.length <= 256 && value.trim() === value && !/[\x00-\x1f\x7f]/.test(value)
export function catalog(value) {
  return keys(value, ['groups']) && Array.isArray(value.groups) && value.groups.length <= 1000 && value.groups.every(group =>
    keys(group, ['tenantId', 'tenantName', 'items']) && text(group.tenantId) && typeof group.tenantName === 'string' &&
    group.tenantName.trim().length > 0 && group.tenantName.length <= 65536 &&
    Array.isArray(group.items) && group.items.length <= 1000 && group.items.every(item =>
      keys(item, ['tenantId', 'userId', 'code']) && item.tenantId === group.tenantId && text(item.userId) && text(item.code)))
}
function https(value) {
  try {
    const url = new URL(value)
    return typeof value === 'string' && url.protocol === 'https:' && !url.username && !url.password && !url.hash && url.href === value ? url : null
  } catch (_) { return null }
}
export function launch(value, code) {
  if (!codes.includes(code)) return false
  const policyApp = code === 'ZEUS' || code === 'ZEREPORTES'
  if (!keys(value, ['applicationId', 'target', policyApp ? 'launchPolicy' : 'launchOrigin']) ||
    value.applicationId !== (code === 'ZEVENDOR' ? 'zeven' : code.toLowerCase()) || typeof value.target !== 'string' || value.target.length > 65536) return false
  const target = https(value.target)
  const cipher = code === 'ANTION' || code === 'ZECHECK' ? 'auth' : 'token'
  if (!target || !/^(?:[a-f0-9]{32})+$/.test(target.searchParams.get(cipher) || '')) return false
  if (policyApp) {
    const policy = value.launchPolicy
    if (!keys(policy, ['ssoLoginBaseUrl', 'launchBaseUrl']) || !https(policy.ssoLoginBaseUrl) || !https(policy.launchBaseUrl) ||
      Array.from(target.searchParams.keys()).join(',') !== 'redirect,token' || target.searchParams.get('redirect') !== policy.launchBaseUrl) return false
    target.search = ''
    return target.href === policy.ssoLoginBaseUrl
  }
  let origin
  try { origin = new URL(value.launchOrigin) } catch (_) { return false }
  if (origin.protocol !== 'https:' || value.launchOrigin !== origin.origin || target.origin !== origin.origin || target.pathname !== '/redirect') return false
  const rich = ['ZEHUB', 'ZEVENDOR', 'ZEPICK'].includes(code)
  const expected = rich ? ['idUser', 'route', 'tenant', 'token', 'username'] : code === 'ZECHECK' ? ['auth', 'user'] : [cipher]
  return Array.from(target.searchParams.keys()).sort().join(',') === expected.join(',') &&
    (!rich || (target.searchParams.get('route') === '' && ['idUser', 'tenant', 'username'].every(key => !!(target.searchParams.get(key) || '').trim()))) &&
    (code !== 'ZECHECK' || !!(target.searchParams.get('user') || '').trim())
}
let sequence = 0
// The authenticated BFF enforces the configured public origin; the browser
// independently checks the exact DTO and canonical handoff shape before leaving.
export function handoff(value) {
  if (!keys(value, ['target', 'expiresIn']) || value.expiresIn !== 120 || typeof value.target !== 'string' || value.target.length > 4096) return false
  try {
    const target = new URL(value.target)
    return target.protocol === 'https:' && !target.username && !target.password && target.href === value.target &&
      target.pathname === '/auth/handoff' && !target.search && !value.target.includes('?') &&
      /^#token=[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/.test(target.hash) && target.hash.slice(7).length <= 2048
  } catch (_) { return false }
}

export function mapCatalog(value, manifest) {
  if (!catalog(value)) throw new Error('Invalid catalog')
  const commands = new Map()
  const generation = ++sequence
  const groups = value.groups.map((group, g) => ({
    id: `group-${generation}-${g}`, label: group.tenantName,
    items: group.items.map((item, i) => {
      const id = `item-${generation}-${g}-${i}`
      const metadata = Object.prototype.hasOwnProperty.call(manifest, item.code) ? manifest[item.code] : null
      const disabled = !codes.includes(item.code)
      if (!disabled) commands.set(id, Object.freeze({ tenantId: item.tenantId, userId: item.userId, applicationCode: item.code }))
      return { id, code: item.code, label: metadata ? metadata.label : item.code, icon: metadata ? metadata.icon : null,
        disabled, disabledReason: disabled ? 'Suite todavía no ofrece un contrato de lanzamiento para esta aplicación.' : undefined }
    }),
  }))
  return { groups, commands }
}
